<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>实习生管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="实习生账号"
                        prop="intern_user_id">
            <remote-select class="width-max"
                           v-model="search.intern_user_id"
                           clearable
                           id-key="id"
                           label-key="name"
                           value-key="id"
                           keyword-key="name"
                           placeholder="请输入账号名搜索"
                           :query-request="queryInternTableApi"
                           :find-request="getInternBaseInfoApi">
            </remote-select>
          </el-form-item>
          <el-form-item label="计划月份"
                        prop="plan_month">
            <el-date-picker class="width-max"
                            v-model="search.plan_month"
                            type="month"
                            value-format="yyyy-MM"
                            placeholder="请选择计划月份"
                            clearable>
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="onExportMonthlyPlan()">
            按条件导出月度统计
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="onExportPlanDates()">
            按条件导出出勤明细
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <el-table :data="table"
                stripe
                highlight-current-row
                border>
        <el-table-column prop="intern_user_id"
                         label="实习生ID"
                         min-width="100">
        </el-table-column>
        <el-table-column prop="intern_name"
                         label="账号名"
                         min-width="140">
        </el-table-column>
        <el-table-column prop="plan_month"
                         label="计划月份"
                         min-width="110">
        </el-table-column>
        <el-table-column prop="planned_days"
                         label="计划出勤天数"
                         min-width="130">
        </el-table-column>
        <el-table-column prop="first_plan_date"
                         label="最早计划日期"
                         min-width="130">
        </el-table-column>
        <el-table-column prop="latest_plan_date"
                         label="最后计划日期"
                         min-width="130">
        </el-table-column>
        <el-table-column prop="updated_at"
                         label="更新时间"
                         min-width="160">
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="120">
          <template slot-scope="scope">
            <router-link :to="`/audit-intern/attendance-plan-detail/${scope.row.intern_user_id}/${scope.row.plan_month}`">
              <el-button type="primary"
                         size="small">查看明细
              </el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table-v3'
import RemoteSelect from '@core/components/RemoteSelect.vue'

export default {
  components: {RemoteSelect},
  mixins: [table],
  data () {
    return {
      search: {
        intern_user_id: null,
        plan_month: null,
      },
      searchFieldType: {
        intern_user_id: Number,
      },
    }
  },
  methods: {
    ...request.map(['queryInternTableApi', 'getInternBaseInfoApi']),
    getTableData (params) {
      return request.common('queryInternAttendancePlanMonthlyApi', params)
    },
    ...request.map(['queryInternAttendancePlanDetailApi']),
    onExportMonthlyPlan () {
      this.$export('导出实习生考勤计划月度统计', {
        fileHeader: [
          {key: 'intern_user_id', text: '实习生ID'},
          {key: 'intern_name', text: '账号名'},
          {key: 'plan_month', text: '计划月份'},
          {key: 'planned_days', text: '计划出勤天数'},
          {key: 'first_plan_date', text: '最早计划日期'},
          {key: 'latest_plan_date', text: '最后计划日期'},
          {key: 'updated_at', text: '更新时间'},
        ],
        total: 0,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
    onExportPlanDates () {
      this.$export('导出实习生考勤计划明细', {
        fileHeader: [
          {key: 'id', text: 'ID'},
          {key: 'intern_user_id', text: '实习生ID'},
          {key: 'intern_name', text: '账号名'},
          {key: 'plan_month', text: '计划月份'},
          {key: 'plan_date', text: '计划日期'},
          {key: 'updated_at', text: '更新时间'},
        ],
        total: 0,
        request: this.queryInternAttendancePlanDetailApi,
        requestParams: this.search,
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/audit-intern/pages/InternAttendancePlanMonthly.vue